export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_ROOM = 'UPDATE_USER_ROOM';
export const LOGGED = 'LOGGED';
export const LOGOUT = 'LOGOUT';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const RECEIVE_INVITATION = 'RECEIVE_INVITATION';
export const INVITATION_SENT = 'INVITATION_SENT';
export const INVITATION_ANSWERED = 'INVITATION_ANSWERED';
export const INVITATION_ARCHIVED = 'INVITATION_ARCHIVED';
export const ROOM_ENTER = 'ROOM_ENTER';
export const ROOM_LEFT = 'ROOM_LEFT';
export const STREAM_RECEIVED = 'STREAM_RECEIVED';
export const STREAM_SUBSCRIBED = 'STREAM_SUBSCRIBED';
export const STREAM_UNSUBSCRIBED = 'STREAM_UNSUBSCRIBED';
export const STREAM_PUBLISHED = 'STREAM_PUBLISHED';
export const STREAM_UNPUBLISHED = 'STREAM_UNPUBLISHED';
export const STREAM_CHANGED = 'STREAM_CHANGED';
export const VIDEO_MUTED = 'VIDEO_MUTED';
export const VIDEO_UNMUTED = 'VIDEO_UNMUTED';
export const AUDIO_MUTED = 'AUDIO_MUTED';
export const AUDIO_UNMUTED = 'AUDIO_UNMUTED';
export const PARTICIPANT_JOIN = 'PARTICIPANT_JOIN';
export const PARTICIPANT_LEFT = 'PARTICIPANT_LEFT';
export const VIDEO_FOCUS = 'VIDEO_FOCUS';
export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED';
export const MESSAGE_SENT = 'MESSAGE_SENT';
export const DEVICES_LISTED = 'DEVICES_LISTED';
export const VIDEO_SWITCH = 'VIDEO_SWITCH';
export const ADD_ROOM = 'ADD_ROOM';
export const UPDATE_ROOM = 'UPDATE_ROOM';
export const DELETE_ROOM = 'DELETE_ROOM';



/** WEBPACK FOOTER **
 ** ./src/js/utils/constants.js
 **/